import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import { authActions } from '@services'

import { SimpleDialog } from '@components/ui'

interface SessionExpiredDialogProps {
  logout: VoidFunction
  sessionExpired: boolean
}

function PureSessionExpiredDialog({ logout, sessionExpired }: SessionExpiredDialogProps) {
  function handleClose() {
    logout()
  }

  return (
    <SimpleDialog
      className="gap-3x"
      open={sessionExpired}
      onClose={handleClose}
      onPrimaryAction={handleClose}
      title={<FormattedMessage id="dialogs.sessionExpired.title" defaultMessage="Lejárt munkamenet" />}
      description={
        <FormattedMessage
          id="dialogs.sessionExpired.text"
          defaultMessage="A munkameneted lejárt. Kérünk jelentkezz be újra."
        />
      }
      size="xs"
    />
  )
}

export const SessionExpiredDialog = connect(
  (state: Store) => ({
    sessionExpired: state.auth.token_expired,
  }),
  {
    logout: authActions.logout.success, // skip logout api call but act as it happened
  }
)(PureSessionExpiredDialog)

SessionExpiredDialog.displayName = 'SessionExpiredDialog'
